import React from 'react';
import { injectIntl } from 'react-intl';
import messages from './messages';

const ResultTotalAnswers = ({ stepAnswers, intl: { formatMessage } }) => {
	const totalAnswers = Object.values(stepAnswers).length;
	return <h5>{`${formatMessage(messages.total)} - ${totalAnswers}`}</h5>;
};

export default injectIntl(ResultTotalAnswers);




// WEBPACK FOOTER //
// ./src/components/ResultTotalAnswers/ResultTotalAnswers.js